import { GetMyExamSyllabussData } from "__generated__/types";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import { urls } from "common/urls";
import { ContentPage } from "domain/admin/common/ContentPage";
import { mySyllabusBreadcrumb } from "domain/pages/breadcrumbs";
import gql from "graphql-tag";
import React from "react";

const GET_EXAM_SYLLABUS = gql`
  query GetMyExamSyllabussData {
    examSyllabusList(filter: { onlyMine: true }) {
      id
      status
      title
    }
  }
`;

export const MyStudies: React.FC = () => {
  const { data, loadingOrError } =
    useSimpleQuery<GetMyExamSyllabussData>(GET_EXAM_SYLLABUS);

  return (
    <ContentPage
      data={data?.examSyllabusList}
      loadingOrError={loadingOrError}
      title="Mitt pensum"
      breadcrumbs={mySyllabusBreadcrumb}
      elementUrl={(id: string) => urls.exam(id)}
      noDataText="Du har ikke valgt pensum enda!"
    />
  );
};
